/**
 *
 */
export default [
    {
        text: 'fecha',
        value: 'created_at',
        sortable: true,
        format: 'date',
    },
    {
        text: 'bodega',
        value: 'wh_warehouse_name',
        sortable: 'wh_warehouse_id',
    },
    {
        text: 'producto',
        value: 'wh_product_name',
        sortable: 'wh_product_id',
        component: {
            custom: 'wh_product_id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'product-update',
                        params: {
                            id: value,
                        },
                    }),
                tooltip: 'Detalle del producto',
            },
        },
    },
    /*{
        text: 'venta sala',
        value: 'normal_sale_total',
        sortable: true,
        align: 'center',
        format: 'number',
    },
    {
        text: 'venta terreno',
        value: 'ground_sale_total',
        sortable: true,
        align: 'center',
        format: 'number',
    },
    {
        text: 'ajuste',
        value: 'stock_adjust_total',
        sortable: true,
        align: 'center',
        format: 'number',
    },
    {
        text: 'compras',
        value: 'purchase_order_total',
        sortable: true,
        align: 'center',
        format: 'number',
    },
    {
        text: 'reenvasado',
        value: 'repacking_total',
        sortable: true,
        align: 'center',
        format: 'number',
    },
    {
        text: 'call center',
        value: 'call_center_sale_total',
        sortable: true,
        align: 'center',
        format: 'number',
    },
    {
        text: 'venta empleado',
        value: 'employee_sale_total',
        sortable: true,
        align: 'center',
        format: 'number',
    },
    {
        text: 'consumo interno',
        value: 'internal_consumption_total',
        sortable: true,
        align: 'center',
        format: 'number',
    },
    {
        text: 'cambio de producto',
        value: 'change_product_customer_total',
        sortable: true,
        align: 'center',
        format: 'number',
    },*/
    {
        text: 'entrada',
        value: 'input_total',
        sortable: true,
        align: 'right',
        format: 'number-point-positive',
        //classes: 'success--text'
    },
    {
        text: 'salida',
        value: 'output_total',
        sortable: true,
        align: 'right',
        format: 'number-point-negative',
        //classes: 'error--text'
    },
    {
        text: 'total',
        value: 'input_output_total',
        align: 'right',
        format: 'number-point-negative-positive',
        //classes: 'primary--text'
    },
    {
        text: 'saldo',
        value: 'final_stock',
        align: 'right',
        format: 'number-point',
    },
]
